export default __webpack_public_path__ + "static/media/Flawless.984b2825.jpg";